import React, { useEffect, useState } from 'react';
import { Phone, MapPin, Mail, ChevronDown } from 'lucide-react';
import HeroSection from '../components/HeroSection';
import AdvantagesSection from '../components/AdvantagesSection';
import FacilitiesSection from '../components/FacilitiesSection';
import GallerySection from '../components/GallerySection';
import MembershipPlans from '../components/MembershipPlans';
import HouseRules from '../components/HouseRules';
import LocationSection from '../components/LocationSection';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';
import Header from '../components/Header';

const Home = () => {
  const [activeSection, setActiveSection] = useState('home');

  useEffect(() => {
    const handleScroll = () => {
      const sections = ['home', 'advantages', 'facilities', 'gallery', 'plans', 'rules', 'location', 'contact'];
      const scrollPosition = window.scrollY + 100;

      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const { offsetTop, offsetHeight } = element;
          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
            setActiveSection(section);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white">
      <Header activeSection={activeSection} />
      <main>
        <section id="home">
          <HeroSection />
        </section>
        <section id="advantages">
          <AdvantagesSection />
        </section>
        <section id="facilities">
          <FacilitiesSection />
        </section>
        <section id="gallery">
          <GallerySection />
        </section>
        <section id="plans">
          <MembershipPlans />
        </section>
        <section id="rules">
          <HouseRules />
        </section>
        <section id="location">
          <LocationSection />
        </section>
        <section id="contact">
          <ContactSection />
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default Home;
